module.exports = __webpack_public_path__ + "img/icon-facebook.c45318e3.svg";